module.exports = __webpack_public_path__ + "static/media/checkbox-circle-fill.2e1bafce.svg";